import { render, staticRenderFns } from "./FmsReportDatalog.vue?vue&type=template&id=670e54df&scoped=true"
import script from "./FmsReportDatalog.vue?vue&type=script&lang=js"
export * from "./FmsReportDatalog.vue?vue&type=script&lang=js"
import style0 from "./FmsReportDatalog.vue?vue&type=style&index=0&id=670e54df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670e54df",
  null
  
)

export default component.exports